import * as Yup from "yup";
import i18n from "../i18n";

export const EmailConfigSchema = Yup.object({
  senderEmail: Yup.string()
    .email(
      i18n.language === "en" ? "Invalid email" : "البريد الإلكتروني غير صالح"
    )
    .required(
      i18n.language === "en"
        ? "Sender email is required"
        : "البريد الإلكتروني للمرسل مطلوب"
    ),
  senderPassword: Yup.string().nullable(),
  server: Yup.string().required(
    i18n.language === "en" ? "Server is required" : "الخادم مطلوب"
  ),
  port: Yup.string().required(
    i18n.language === "en" ? "Port is required" : "البورت مطلوب"
  ),
  testEmail: Yup.string(),

  enableSsl: Yup.boolean(),
  enableVisitRequestSubmitEmailToVisitor: Yup.boolean(),
  enableVisitApprovalEmail: Yup.boolean(),
  enableExternalCancelEmailToVisitor: Yup.boolean(),
  enableExternalCancelEmailToHost: Yup.boolean(),
  enableVisitRejectedEmailToVisitor: Yup.boolean(),
  enableVisitRejectedEmailToHost: Yup.boolean(),
  enableVisitApprovedScheduledEmailToVisitor: Yup.boolean(),
  enableVisitApprovedScheduledEmailToHost: Yup.boolean(),
  enableDevicesRejectedEmailToVisitor: Yup.boolean(),
  enableDevicesRejectedEmailToHost: Yup.boolean(),
  enableExternalRegistrationEmailToVisitor: Yup.boolean(),
  enableExternalPasswordResetEmailToVisitor: Yup.boolean(),
  enableCheckInEmail: Yup.boolean(),
  enableCheckOutEmail: Yup.boolean(),
  enableOTPEmail: Yup.boolean(),

  finalPermitApprovalRecipients: Yup.string(),
});
